module.exports = __webpack_public_path__ + "img/banner_cf_23.4bbfd992.png";